const GRAPH_DESCRIPTION = {
    ordersOverTime: `This chart is an illustration of Orders over time. Use this data to understand sales patterns and customer engagement across selected location and categories. The values depicted are relatively scaled with the maximum value set at 100 percentile`,

    rtoOverTime: `This chart is an illustration of RTO rates  across different regions for your category of products`,

    prepaidVsCod: `This chart is an illustration of Prepaid/COD comparison across different regions for your category of products`,

    gmVoverTime: `This chart is an illustration of GMV over Time. Use this data to understand GMV generated across selected location and categories.The values depicted are relatively scaled with the maximum value set at 100 percentile`,

    categoryInsights: `This graph showcases the popularity of product categories over time in a region. The lines 
    represent different categories, helping you identify which products are gaining or 
    losing market interest`,

    subCategoryInsights: `This graph showcases the popularity of product sub-categories over time in a region. The lines 
    represent different sub-categories, helping you identify which products are gaining or 
    losing market interest` ,

    productInsights: `This graph showcases the popularity of products over time in a region. The lines 
    represent different products, helping you identify which products are gaining or 
    losing market interest`,

    OrderValueDistribution: `This chart gives an illustration of order value distributed by various buckets of monetary value.`,
    GMVGenerated: `This scorecard is an indicator of increase or decrease in GMV in last month`,
    DiscountedOrders: `This scorecard is an indicator of increase or decrease in Discounted Orders % in last month`,
    AOV: `This scorecard is an indicator of increase or decrease in Average Order Value in last month`,
    RTO: `This scorecard is an indicator of increase or decrease in Return To Origin (RTO) % in last month`,
    PrepaidCOD: `This chart gives a percentage split of Prepaid and COD Orders`,
    NewRepeatBuyer: `This chart gives a percentage split of New and Repeat Buyers`,
    BuyerSegments: `This chart illustrates the different segments of buyers based on their purchasing behavior`,
    OrderPlacementTimings: `This chart provides a detailed analysis of order placement timings, categorized by different days of the week and specific quadrants of the day. The quadrants of the day are typically divided into Morning (12 AM - 6 AM), Midday (6 AM - 12 PM), Afternoon (12 PM - 6 PM), and Evening (6 PM - 12 AM).`,

}


export default GRAPH_DESCRIPTION